import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Image } from "semantic-ui-react";
import { TitleCase } from "../../common";
import Lightbox from "react-images";

class StaticImageField extends Component {
  constructor() {
    super();
    this.state = {
      lightboxIsOpen: false
    };
  }

  closeLightbox() {
    this.setState({ lightboxIsOpen: false });
  }

  openLightbox() {
    this.setState({ lightboxIsOpen: true });
  }

  render() {
    const { element_prompt, element_value, ...formControl } = this.props;
    let imgUri = formControl.element_params.R;
    return (
      <div className="formControlItem">
        <Form.Field>
          <label style={{ fontWeight: "bold" }}>
            {TitleCase(element_prompt)}
            <span className="optionalField"></span>
          </label>
          <Image
            style={{ cursor: "zoom-in", borderRadius: "0.28571429rem" }}
            onClick={this.openLightbox.bind(this)}
            width={250}
            src={imgUri}
          />
          <Lightbox
            showImageCount={false}
            images={[{ src: imgUri }]}
            isOpen={this.state.lightboxIsOpen}
            onClose={this.closeLightbox.bind(this)}
          />
        </Form.Field>
      </div>
    );
  }
}

StaticImageField.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired
};

export default StaticImageField;



// WEBPACK FOOTER //
// ./src/components/StaticImageField/index.js